<template>
  <div>

    <div class="row">
      <div class="col-12">
        <div class="vertical-tab">
          <div v-if="id" class="card card-with-search border-0 card-with-shadow">
            <div class="text-justify">
              <app-tab :tabs="tabsHorizontal" type="horizontal" />
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {ModalMixin} from "@/app/Mixins/ModalMixin";
import {mapState} from "vuex";

export default {
  name: "FormDetail",
  mixins: [ModalMixin],
  props: {
    id: Number,
  },
  data() {
    return {
      formDataString:'',
      taskFormData:{},
      tabsHorizontal: [
        {
          icon: "users",
          name: "All",
          component: "FormResponse",
          permission: "",
          props: {id:this.id, status:''}
        },
        {
          icon: "users",
          name: "Pending",
          component: "FormResponse",
          permission: "",
          props: {id:this.id, status:'pending'}
        },
        {
          icon: "info",
          name: "Approved",
          component: "FormResponse",
          permission: "",
          props: {id:this.id, status:'approved'}
        },
        {
          icon: "link",
          name: "Rejected",
          component: "FormResponse",
          permission: "",
          props: {id:this.id, status:'rejected'}
        },
        {
          icon: "link",
          name: "Get Form Link",
          component: "AssignTaskForm",
          permission: "",
          props: {id:this.id}
        },



      ],
    };
  },
  methods: {
    previous() {
      this.active = 1;
    },
    },

    getQueryParam() {
      let uri = window.location.search.substring(1);
      let params = new URLSearchParams(uri);
      return params.get("form_id");
    },
  created() {

  },
  
  computed: {
    ...mapState['sharedData'],
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
    themeMode() {
      return this.$store.state.theme;
    },
    formData(){
      let jsonString = this.$store.state.sharedData.sharedData.taskForms;
      this.taskFormData = JSON.parse(jsonString)
      return this.taskFormData
    },
    form(){
      let id = this.id;
      let form = {};
      if (this.taskFormData.data){
        form = this.taskFormData.data.find((item) => item.id === id);
      }
      return form;
    },
    taskFormRevisionId(){
     return this.$store.state.sharedData.sharedData.formRevisionId
    },

  },
  mounted() {
    debugger
   // this.getFormDetails()

  },
};
</script>
